"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillTextPositions = void 0;
const shared_utils_1 = require("@d-fischer/shared-utils");
/** @private */
function fillTextPositions(message, otherPositions) {
    const messageLength = shared_utils_1.utf8Length(message);
    if (!otherPositions.length) {
        return [
            {
                type: 'text',
                position: 0,
                length: messageLength,
                text: message
            }
        ];
    }
    const result = [];
    let currentPosition = 0;
    for (const token of otherPositions) {
        if (token.position > currentPosition) {
            result.push({
                type: 'text',
                position: currentPosition,
                length: token.position - currentPosition,
                text: shared_utils_1.utf8Substring(message, currentPosition, token.position)
            });
        }
        result.push(token);
        currentPosition = token.position + token.length;
    }
    if (currentPosition < messageLength) {
        result.push({
            type: 'text',
            position: currentPosition,
            length: messageLength - currentPosition,
            text: shared_utils_1.utf8Substring(message, currentPosition)
        });
    }
    return result;
}
exports.fillTextPositions = fillTextPositions;
